// Module-specific paths now live with their module, in
// src/modules/<Module>/paths.ts, and are merged by src/app/paths.ts.
// This file keeps re-exporting `paths` so existing consumers are unchanged,
// and owns the path-generation helpers below.
import { paths } from '@/app/paths'

export { paths }

// Type to extract dynamic params from the path
type PathParams<Path extends string> =
    Path extends `${string}:${infer Param}/${infer Rest}`
        ? { [K in Param | keyof PathParams<`/${Rest}`>]: string }
        : Path extends `${string}:${infer Param}`
          ? { [K in Param]: string }
          : {}

// Type mapping for all paths
type Paths = typeof paths
export type RouteParams<T extends keyof Paths> = PathParams<Paths[T]>

// Modified generatePath function
export const generatePathDatacentral = <T extends keyof Paths>(
    path: Paths[T],
    params: RouteParams<T>,
    query?: Record<string, string | number | (string | number)[] | undefined>
): string => {
    let newPath = path as string

    // Replace các dynamic params trong path
    for (const key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key)) {
            newPath = newPath.replace(`:${key}`, (params as any)[key])
        }
    }

    // Build query string nếu có
    if (query && Object.keys(query).length > 0) {
        const searchParams = new URLSearchParams()

        for (const [key, value] of Object.entries(query)) {
            if (value === undefined) continue

            if (Array.isArray(value)) {
                // Nếu là array, append nhiều lần (filters=a&filters=b)
                value.forEach((v) => searchParams.append(key, String(v)))
            } else {
                searchParams.append(key, String(value))
            }
        }

        newPath += `?${searchParams.toString()}`
    }

    return newPath
}
